<template>
  <div v-loading="loading" style="height: 350px;width: 100%;" />
</template>

<script>
import { newEquipCurveApi, totalEquipCurveApi, newMemberCurveApi, totalMemberCurve, newDevCurveApi, incomeCountCurveApi, incomeSumCurveApi } from '@/api/common/reportApi'
import { debounce } from '@/utils/common'

export default {
  name: 'ReportLine',

  props: {
    active: {
      type: String,
      default: '新增设备'
    },

    type: {
      type: String,
      default: 'day'
    }
  },

  data() {
    return {
      loading: false,
      stats: {},
      chart: null,
      chartOption: {
        title: {
        },
        legend: {
          show: false,
          bottom: 0
        },
        grid: {
          left: 10,
          right: 10,
          bottom: 50,
          top: 50,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          data: [],
          boundaryGap: true
        },
        yAxis: [{
          type: 'value'
        }],
        series: [
          {
            name: this.active,
            type: 'line',
            smooth: false,
            data: []
          }
        ]
      }
    }
  },

  watch: {
    active: function(newVal,oval) {
      this.fetchData()
    },

    type: function(newVal,oval) {
      this.fetchData()
    },
  },

  mounted() {
    this.initChart()
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },

  created: function() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      let requestApi
      if (this.active == '新增设备') requestApi = newEquipCurveApi
      if (this.active == '新增用户') requestApi = newMemberCurveApi
      if (this.active == '新增模型') requestApi = newDevCurveApi
      if (this.active == '收入笔数') requestApi = incomeCountCurveApi
      if (this.active == '累计设备') requestApi = totalEquipCurveApi
      if (this.active == '累计用户') requestApi = totalMemberCurve
      if (this.active == '收入金额') requestApi = incomeSumCurveApi
      requestApi({ type: this.type }).then(res => {
        this.loading = false
        if (res.errno === 0) {
          this.stats = Object.assign({}, res.data)
          this.setChart()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    setChart() {
      this.chartOption.xAxis.data = this.stats.x_data
      this.chartOption.series[0].data = this.stats.y_data
      this.chartOption.series[0].name = this.active
      if (this.active == '收入金额') this.chartOption.formatter = '{b}<br/>收入金额：￥{c}'
      if (this.active != '收入金额') this.chartOption.formatter = '{b}<br/>' + this.active + '：{c}'
      this.chart.setOption(this.chartOption)
    },

    initChart() {
      this.chart = this.$echarts.init(this.$el, 'teenager')
      this.chart.setOption(this.chartOption)
    }
  }
}
</script>
